import $ from 'jquery';
import EFOcats_pattern_core from './efocats_pattern_core';

/**
 * 姓名入力の処理パターン化
 */
export default class EFOcats_pattern_seimei extends EFOcats_pattern_core {
  /**
   * コンストラクタ
   * @param {*} opt オプション
   */
  constructor(kanamode, pagemode, opt) {
    opt.kanamode = kanamode;
    opt.pagemode = pagemode;

    if (opt.seimei !== undefined && opt.seimei_kana !== undefined) {
      opt.inputmode = 'single';
    } else if (opt.sei !== undefined && opt.mei !== undefined && opt.sei_kana !== undefined && opt.mei_kana !== undefined) {
      opt.inputmode = 'double';
    } else {
      throw 'invalid opt value';
    }

    super(opt);

    // かなの変換モードのチェック
    if (opt.kanamode !== 'kana' && opt.kanamode !== 'hiragana') {
      throw 'invalid kana_mode value';
    }

    // ページの分割モードのチェック
    if (opt.pagemode !== 'single' && opt.pagemode !== 'double') {
      throw 'invalid page_mode value';
    }
  }

  /**
   * 読み込んだフォームをページごとに分割する
   * @param {*} form 読み込んだフォームのHTMLElement
   * @param {*} pages coreで生成されたページ一覧
   * @returns ページ一覧
   */
  get_pages(form, pages) {
    if (this.opt.pagemode === 'single') {
      let nameIndex = -1;
      let kanaIndex = -1;

      for (let index = 0; index < pages.length; index++) {
        const page = pages[index];
        if ($(page).find(`[name="${this.opt.sei}"]`).length > 0 || $(page).find(`[name="${this.opt.seimei}"]`).length > 0) {
          nameIndex = index;
        }
        if ($(page).find(`[name="${this.opt.sei_kana}"]`).length > 0 || $(page).find(`[name="${this.opt.seimei_kana}"]`).length > 0) {
          kanaIndex = index;
        }
      }

      if (nameIndex !== kanaIndex) {
        // eslint-disable-next-line operator-assignment
        pages[nameIndex] = pages[nameIndex] + pages[kanaIndex];
        pages.splice(kanaIndex, 1);
      }
    }

    return pages;
  }

  /**
   * 入力欄の属性を設定する
   * @param {*} page
   * @param {*} inputs
   * @param {*} index
   * @param {*} tempanswer
   */
  get_attr(page, inputs, index, tempanswer) {
    const name = $(inputs[index]).attr('name');
    const singlePage = this.opt.pagemode === 'single';

    switch (name) {
      case this.opt.seimei:
        tempanswer.autocomplete = 'name';
        tempanswer['data-input'] = 'inputSeiMei';

        if (singlePage) {
          tempanswer.line = 0;
        }

        break;
      case this.opt.seimei_kana:
        tempanswer['data-input'] = 'outputSeiMei';
        this.addValidate(tempanswer);

        if (singlePage) {
          tempanswer.line = 1;
        }

        break;
      case this.opt.sei:
        tempanswer.autocomplete = 'family-name';
        tempanswer['data-input'] = 'inputSei';

        if (singlePage) {
          tempanswer.line = 0;
        }

        break;
      case this.opt.sei_kana:
        tempanswer['data-input'] = 'outputSei';
        this.addValidate(tempanswer);

        if (singlePage) {
          tempanswer.line = 1;
        }

        break;
      case this.opt.mei:
        tempanswer.autocomplete = 'given-name';
        tempanswer['data-input'] = 'inputMei';

        if (singlePage) {
          tempanswer.line = 0;
        }

        break;
      case this.opt.mei_kana:
        tempanswer['data-input'] = 'outputMei';
        this.addValidate(tempanswer);

        if (singlePage) {
          tempanswer.line = 1;
          tempanswer.index = 1;
        }

        break;
      default:
        break;
    }
  }

  addValidate(tempanswer) {
    if (tempanswer['validate-type'] === undefined) {
      tempanswer['validate-type'] = this.opt.kanamode;
    } else if (Array.isArray(tempanswer['validate-type'])) {
      tempanswer['validate-type'].push(this.opt.kanamode);
    } else {
      const org = tempanswer['validate-type'];
      tempanswer['validate-type'] = [org];
      tempanswer['validate-type'].push(this.opt.kanamode);
    }
  }

  /**
   * ページデータの拡張
   * @param {*} page
   * @param {*} temp
   */
  pagedata_extend(page, temp) {
    if (this.opt.kanamode === 'hiragana') {
      window.efocats.events.input.katakana = false;
    }
  }
}
